/**
 * 隐藏手机号码
 * @param val {Number, String} 转换的字符串对象
 * @param retain {Number} 保留位数
 * @return {String}
 */
export function privatePhone(val, retain = 4) {
  if (!Number(val) || String(val).length !== 11 || retain == 0) return val;
  let phone = String(val)
  let digit = 11 - 3 - retain
  let reg = new RegExp(`^(\\d{3})\\d{${digit}}(\\d{${retain}})$`)
  return phone.replace(reg, `$1${'*'.repeat(digit)}$2`)
}
/**
 * 金额格式化  数字格式化 1234567890 --> 1,234,567,890
 * @param str {Number, String} 转换的字符串对象
 * @return {String}
 */
export function amountFormatting(str) {
  var strs = str.toString()
  return strs.split("").reverse().reduce((prev, next, index) => {
    return ((index % 3) ? next : (next + ',')) + prev
  })
}
/*
 * @param time 时间戳转换时间
 * @param type (默认'yyyy-MM-dd HH:mm')
 * @param format
 *
 */
export function formatDate(time, type = "yyyy-MM-dd HH:mm", format) {
  var date = "";
  if (format) {
    date = time;
  } else {
    if (typeof time !== "number") {
      time = time.replace(/-/g, "/");
    }
    date = new Date(time);
  }
  var seperator1 = "-";
  var seperator2 = ":";
  var month = (date.getMonth() + 1).toString();
  var day = date.getDate().toString();
  var hours = date.getHours().toString();
  var minutes = date.getMinutes().toString();
  var seconds = date.getSeconds().toString();

  month = month.length === 1 ? ("0" + month) : month;
  day = day.length === 1 ? ("0" + day) : day;
  hours = hours.length === 1 ? ("0" + hours) : hours;
  minutes = minutes.length === 1 ? ("0" + minutes) : minutes;
  seconds = seconds.length === 1 ? ("0" + seconds) : seconds;
  if (type === "yyyy-MM-dd HH:mm:ss") {
    return date.getFullYear() + seperator1 + month + seperator1 + day + " " + hours + seperator2 + minutes + seperator2 + seconds;
  } else if (type === "yyyy-MM-dd HH:mm") {
    return date.getFullYear() + seperator1 + month + seperator1 + day + " " + hours + seperator2 + minutes;
  } else if (type === "yyyy-MM-dd") {
    return date.getFullYear() + seperator1 + month + seperator1 + day;
  } else if (type === "yyyy-MM") {
    return date.getFullYear() + seperator1 + month;
  } else if (type === "HH:mm") {
    return hours + seperator2 + minutes;
  }
}
//去除空格 type 1-所有空格 2-前后空格 3-前空格 4-后空格
export function stringTrim(value, trim) {
  switch (trim) {
    case 1:
      return value.replace(/\s+/g, "");
    case 2:
      return value.replace(/(^\s*)|(\s*$)/g, "");
    case 3:
      return value.replace(/(^\s*)/g, "");
    case 4:
      return value.replace(/(\s*$)/g, "");
    default:
      return value;
  }
}

//保留2位小数
export function toDecimal2(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
}
//保留1位小数
export function toDecimal1(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  var f = Math.round(x * 10) / 10;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 1) {
    s += '0';
  }
  return s;
}
export function switchTimeFormat(time, type) {
  const dateTime = new Date(time)
  const year = dateTime.getFullYear()
  const month = dateTime.getMonth() + 1
  const date = dateTime.getDate()
  const hour = dateTime.getHours()
  const minute = dateTime.getMinutes()
  const second = dateTime.getSeconds()
  if (!type) {
    return year + '-' + addZero(month) + '-' + addZero(date)
  } else {
    return year + '-' + addZero(month) + '-' + addZero(date) + ' ' + addZero(hour) + ':' + addZero(minute) + ':' + addZero(second)
  }
}
export function addZero(v) {
  return v < 10 ? '0' + v : v
}
export function moneyFormat(value) {
  let num;
  if (value > 9999) { //大于9999显示x.xx万
    num = (Math.floor(value / 1000) / 10) + '万';
  } else if (value < 9999 && value > 0) {
    num = value
  }
  return num;
}



// WEBPACK FOOTER //
// ./src/filters/index.js